import { MAIN_CURRENCY } from 'config/constants/links'

// ETH
export const DEFAULT_INPUT_CURRENCY = MAIN_CURRENCY
// BUSD
// export const DEFAULT_OUTPUT_CURRENCY = '0x7F2c575cd950d6EefDC291cc9B143DCD6F0652dd'
export const DEFAULT_OUTPUT_CURRENCY = '0xdAC17F958D2ee523a2206206994597C13D831ec7'
